import React from "react";
import "./Category.scss";

function Category() {
  return (
    <div className="Category">
      <div className="category-content center">
        <h3 className="heading">Comics</h3>
      </div>
    </div>
  );
}

export default Category;
